import { Component, input, output } from '@angular/core';
import { TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';
import type { ReviewInductionView } from '../../utils/map-review-induction';
import { ReviewDetailCard } from '../review-detail-card/review-detail-card';

/**
 * Drop-off, Schedule a Pickup, or Create label only summary card on Review & Pay.
 */
@Component({
  selector: 'app-review-induction-summary',
  imports: [ReviewDetailCard, TranslatePipe, TypographyComponent],
  templateUrl: './review-induction-summary.html',
  styleUrl: './review-induction-summary.scss',
})
export class ReviewInductionSummary {
  readonly view = input.required<ReviewInductionView>();
  /** Home Locator URL opened in a new tab from the drop-off copy. */
  readonly locatorUrl = input('');
  /** When false, hides Edit (Get Labels confirmation). */
  readonly showEdit = input(true);
  readonly editRequested = output<string>();
}
